// Splash Video
export const SPLASH_VIDEO = 'video/splash.mp4'

export namespace Images {
  export const LOGO = 'images/logo.png'
  export const APP_ICON = 'images/icon.png'

  export const LOGO_SMALL = 'images/logo-small.svg'
  export const LOGO_LARGE = 'images/logo-large.svg'
  export const IMG_PLACEHOLDER = 'images/img-placeholder.svg'
  export const LOGO_FADED = 'images/logo-faded.svg'
  export const LOGO_OUTLINE_PARTIAL = 'images/logo-outline-partial.svg'
  export const DASHED_CIRCLE = 'images/dashed-circle.svg'
  export const LOGO_SPRITESHEET = 'images/logo-spritesheet.png'

  export const ARROW_POINTER = 'images/arrow-pointer.svg'

  // Settings imgs
  export const SETTINGS_USER = 'images/settings-user.svg'
  export const SETTINGS_SUBSCRIPTION = 'images/settings-subscription.svg'
  export const SETTINGS_CUSTOMER_SUPPORT = 'images/settings-customer-support.svg'
  export const SETTINGS_LIVE_SCORES = 'images/settings-live-scores.svg'

  // Gradients
  export const LANDING_BG = 'images/landing-bg.png'
  export const SPOTLIGHT_BG = 'images/spotlight-overlay.svg'
  export const FOCUS_GRADIENT_FRONT = 'images/focus-gradient-front.svg'
  export const FOCUS_GRADIENT_MIDDLE = 'images/focus-gradient-middle.svg'
  export const FOCUS_GRADIENT_BACK = 'images/focus-gradient-back.svg'
  export const BACKGROUND_IMG_MASK = 'images/background-img-mask.svg'
  export const TV_NAVIGATION_CARD_BLUR = 'images/tv-navigation-card-blur.svg'
  export const BANNER_MESSAGE_FOCUS_GRADIENT = 'images/banner-message-focus-gradient.svg'
  export const PLAYER_CONTROLS_GRADIENT = 'images/player-controls-gradient.svg'

  // Login
  export const LOGIN_WITH_SMARTPHONE_BG = 'images/login-with-smartphone-bg.png'
  export const LOGIN_WITH_REMOTE_BG = 'images/login-with-remote-bg.png'
  export const FORGOT_PASSWORD_BG = 'images/panel-bg.png'

  // Sign Up
  export const SIGN_UP_PRODUCT_INFO_BG = 'images/signup-product-info-bg.png'
  export const SIGN_UP_PRODUCT_INFO_CHECK = 'icons/icon-check-circle.svg'
  export const SIGN_UP_EMAIL_BG = 'images/panel-bg.png'
  export const SIGN_UP_PASSWORD_BG = 'images/panel-bg.png'
  export const SIGN_UP_SUCCESS_BG = 'images/panel-bg.png'

  // Player
  export const PLAYER_THUMB = 'icons/player/thumb.svg'
  export const PLAYER_REPLAY = 'icons/player/replay.png'
  export const PLAYER_PREV = 'icons/player/prev.png'
  export const PLAYER_RW = 'icons/player/rw.png'
  export const PLAYER_PLAY = 'icons/player/play.svg'
  export const PLAYER_PAUSE = 'icons/player/pause.svg'
  export const PLAYER_FF = 'icons/player/ff.png'
  export const PLAYER_NEXT = 'icons/player/next.png'
  export const PLAYER_NO_AUDIO = 'icons/player/play.svg'
  export const PLAYER_SCORES_OFF = 'icons/player/scores_off.svg'
  export const PLAYER_BRACKETS_OFF = 'icons/player/brackets_off.svg'
  export const PLAYER_FEEDBACK_OFF = 'icons/player/feedback_off.svg'
  export const PLAYER_SEEK_JUMP = 'icons/player/seek_jump.svg'
  export const PLAYER_SEPARATOR = 'icons/player/separator.svg'
  export const PLAYER_SPEED_INDICATOR = 'icons/player/speed_indicator.svg'
  export const PLAYER_CC_ON = 'icons/player/cc_on.png'
  export const PLAYERCC_OFF = 'icons/player/cc_off.png'
}

export namespace Fonts {
  export const UNI_NEUE_LIGHT = './fonts/UniNeueLight.ttf'
  export const UNI_NEUE_BOLD = './fonts/UniNeueBold.ttf'
  export const UNI_NEUE_BOOK = './fonts/UniNeueBook.ttf'
  export const UNI_NEUE_HEAVY = './fonts/UniNeueHeavy.ttf'
  export const UNI_NEUE_REGULAR = './fonts/UniNeueRegular.ttf'
}
